const makeAuthPassport = (Http) => {
  const accessToken = (login, pass) => {
    const data = {
      grant_type: 'password',
      client_id: process.env.VUE_APP_CLIENT_ID,
      client_secret: process.env.VUE_APP_CLIENT_SECRET,
      username: login,
      password: pass,
      scope: '',
    };
    return Http.post('/oauth/token', data);
  };

  const refreshToken = (token) => {
    const data = {
      grant_type: 'refresh_token',
      client_id: process.env.VUE_APP_CLIENT_ID,
      client_secret: process.env.VUE_APP_CLIENT_SECRET,
      refresh_token: token,
      scope: '',
    };
    return Http.post('/oauth/token', data);
  };

  const logout = () => Http.post('api/auth/logout');

  const me = () => Http.post('api/auth/me');

  const update = (data, id) => Http.put(`api/auth/update/${id}`, data);

  return {
    accessToken,
    refreshToken,
    logout,
    me,
    update,
  };
};

export default makeAuthPassport;
